export default __webpack_public_path__ + "static/media/img8.1e79549c.jpg";